import axios from "../helpers/axios";

const FCM_SERVER_KEY = "AAAAzHL91ZA:APA91bGQyg2Y9BpsHT32s9xQQuKuTtlbVe1bxuut6PtzIXDA-6UxcORIuUmW71mdampl8bqrcZEgG0d1jh3xy3dbD_gyvuET6zC2rihgtpTlrGnH1J5qeUumw6IuviU38PcKL_yIAPUW"; // Replace with your Firebase Server Key
const DEVICE_TOKEN = "cPXe-j3MSgCPbPkSOSaq6b:APA91bH0Jx6TCACk7jBUsUlFcwJekZhYRnRbLPZ2tFLELAkbPwFOz9c9uK4xG6Z52yNnK5VePZBZlJuGnjOuv84qCbxyDYyBSzKJQ_kMCl76Pyt4Fe1lOWgo13viPtlLNwXfYX8-MvOB"; // Replace with your actual device token

export const sendPushNotification = async () => {
  try {
    const response = await axios.post("http://localhost:8000/send-notification", {
      // Match backend port
      deviceToken: DEVICE_TOKEN, // Replace with actual token
      title: "Test Notification",
      body: "This is a test notification from frontend",
    });

    const data = await response.json();
    console.log("Notification Response:", data);
  } catch (error) {
    console.error("Error sending notification:", error.response ? error.response.data : error.message);
  }
};
